import React, { useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function ExportButton({ path, params, filename, label, testid }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(path, { params, responseType: "blob", timeout: 120000 });
      const cd = r.headers["content-disposition"] || "";
      const name = (cd.match(/filename="([^"]+)"/) || [])[1] || filename;
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
      toast.success("Excel dosyası indirildi");
    } catch {
      toast.error("Dışa aktarma başarısız");
    } finally { setBusy(false); }
  };
  return (
    <button data-testid={testid} onClick={download} disabled={busy} className="kz-btn-outline text-sm py-2 px-4">
      <FileSpreadsheet size={16} className="text-green-700"/> {busy ? "Hazırlanıyor..." : label}
    </button>
  );
}
